// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2qXIy","footer":"ModalFilter_footer__nW3ZF"};